import { post } from "./axiosClient"

type SendHelpRequestProps = {
    id: number,
    token: string
}

type SendHelpRequestResponse = {
    sucessMessage?: string,
    errorMessage?: string
}

export const sendHelpRequest = async ({ id, token }: SendHelpRequestProps): Promise<SendHelpRequestResponse> => {
    return await post({
        data: {},
        params: { helpId: id },
        path: 'websystem/help',
        token: token
    }).then((res) => {
        if (res.status === 200) {
            return { sucessMessage: res.data }

        } else if (res.status === 400) {
            return { errorMessage: res.data }
        } else {
            return { errorMessage: 'Do�lo k ne�ekan� chyb� :(' }
        }
    })
}